/** Browser tab / nav label (TC-SPW-HIS-01). */
export const HISTORY_PAGE_TITLE = 'History'

/** In-page section heading (TC-SPW-HIS-02). */
export const HISTORY_SECTION_TITLE = 'History'

export const HISTORY_SUBTITLE = 'View your previously completed surveys and reward redemptions'

export const HISTORY_EMPTY_MESSAGE =
  "You haven't completed any surveys yet. Check the Home page for available surveys."

export const HISTORY_LOAD_ERROR_TOAST = 'Unable to load history. Please try again.'

export const HISTORY_RETRY_LABEL = 'Retry'

export const HISTORY_LOAD_MORE_LABEL = 'Load More'
